import { useNavigate } from 'react-router-dom';
import { ProjectNotificationType } from './types';
import { useNewProjectUrl } from 'domain/shared/newProject';
import ProjectNotificationButton from './ProjectNotificationButton';
import useDismissNotifications from './useDismissNotifications';
import { getNotificationProjectId } from './notificationUtils';
import { getProjectNotificationActionLabel, getProjectNotificationTargetUrl } from './routing';

const ProjectNotification = ({ response }: { response: ProjectNotificationType[] }) => {
  const { getControlsUrl, getAssumptionsUrl, getStakeholdersUrl, getEngineeringUrl } = useNewProjectUrl();
  const navigate = useNavigate();
  const dismissNotifications = useDismissNotifications();

  const onClickFunc = async (confirmAction: string | undefined, projectId: string, id: string, entityType?: string) => {
    navigate(
      getProjectNotificationTargetUrl({
        confirmAction,
        projectId,
        entityType,
        routes: {
          getControlsUrl,
          getAssumptionsUrl,
          getStakeholdersUrl,
          getEngineeringUrl,
        },
      }),
    );

    await dismissNotifications([id]);
  };

  return response.map(notification => {
    const confirmAction = notification.metadata?.confirmAction;
    const entityType = notification.metadata?.entityType;
    const projectId = getNotificationProjectId(notification);

    return (
      <ProjectNotificationButton
        description={''}
        actionLabel={getProjectNotificationActionLabel(entityType)}
        key={notification.id}
        project={notification}
        onClick={() =>
          notification && projectId ? onClickFunc(confirmAction, projectId, notification.id, entityType) : undefined
        }
      />
    );
  });
};

export default ProjectNotification;
